import React from 'react';
import { isNull } from 'lodash';
import SearchBox from '../../../../components/outline/SearchBox';
import BaseForm from '../../../../components/form/BaseForm';
import TextArea from '../../../../components/input/TextArea';
import Select from '../../../../components/input/Select';
import { addAllItemToSelectList, setIfNull, setTrim } from '../../../../lib/common';
import {
  MAXIMUM_NUMBER_OF_SEARCH_BOX_USER_ID,
  POINT_LOG_TYPE,
  POINT_LOG_TYPE_SELECT_LIST,
} from '../../../../constants/service/app/pointConstants';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import { POINT_LIST_SEARCH_OPTION_MODEL } from '../../../../store/modules/point/models';
import './PointListSearchBox.scss';

const PointListSearchBox = (props) => {
  const { pointCauseSelectList, setData, searchData, getList, adminSelectList } = props;
  const { userId, type, cause, adminIdList } = searchData;

  return (
    <SearchBox
      className="point-list-search-box"
      onSearch={() => {
        getList({
          searchOption: searchData,
          pagination: LIST_PAGINATION_MODEL,
        });
      }}
      onClear={() => {
        getList({
          searchOption: POINT_LIST_SEARCH_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        });
        setData({
          path: [],
          value: POINT_LIST_SEARCH_OPTION_MODEL,
        });
      }}
    >
      {/*userId 로 검색 input*/}
      <BaseForm
        label="유저 ID"
        content={
          <div className="input-search-wrap">
            <TextArea
              value={userId}
              maxLength={MAXIMUM_NUMBER_OF_SEARCH_BOX_USER_ID}
              onChange={(value) => {
                setData({
                  path: ['userId'],
                  value: setIfNull(setTrim(value)),
                });
              }}
              onPressEnter={() =>
                getList({
                  searchOption: searchData,
                  pagination: LIST_PAGINATION_MODEL,
                })
              }
            />
          </div>
        }
      />

      {/*type 으로 검색하는 select*/}
      <BaseForm
        label="내역 종류"
        content={
          <div className="select-search-wrap">
            <Select
              className="select-search-option"
              value={type}
              list={POINT_LOG_TYPE_SELECT_LIST}
              onChange={(value) => {
                setData({
                  path: ['type'],
                  value,
                });
                setData({
                  path: ['cause'],
                  value: null,
                });
              }}
            />
          </div>
        }
      />

      {/*cause 로 검색하는 select*/}
      <BaseForm
        label="적립/사용처"
        content={
          <div className="select-search-wrap">
            <Select
              className="select-search-option"
              list={
                type === POINT_LOG_TYPE.SAVE
                  ? addAllItemToSelectList(pointCauseSelectList.filter((item) => item.type === POINT_LOG_TYPE.SAVE))
                  : addAllItemToSelectList(pointCauseSelectList.filter((item) => item.type === POINT_LOG_TYPE.USE))
              }
              value={cause}
              disabled={isNull(type)}
              onChange={(value) => {
                setData({
                  path: ['cause'],
                  value,
                });
              }}
            />
          </div>
        }
      />

      {/*adminName 로 검색 input*/}
      <BaseForm
        label="발급한 관리자"
        content={
          <div className="input-search-wrap">
            <Select
              showSearch
              optionFilterProp="children"
              list={adminSelectList}
              onChange={(value) =>
                setData({
                  path: ['adminIdList'],
                  value,
                })
              }
              mode="multiple"
              defaultValue={adminIdList}
              value={adminIdList}
              isTable={false}
            />
          </div>
        }
      />
    </SearchBox>
  );
};

export default PointListSearchBox;
